export default "__VITE_ASSET__C7buRDo2__"